import { createColumnHelper } from "@tanstack/react-table";
// import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useHospital1on1List } from "../../../../api/member-management/use-hospital-1on1";
import Table from "../../../../components/ui/Table/Table";
import { convertDateToDateTime } from "../../../../helper/formatDate/formate-date";
import { indexer } from "../../../../utils/utils";

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);

        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "처리상태",
      cell: (info) => {
        const val = info.getValue();
        return (
          <div>
            {val ? (
              val === "PENDING" ? (
                <span className="text-[#e80000]">답변대기</span>
              ) : (
                "답변완료"
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    }),

    // columnHelper.accessor((row) => row?.hospitalMember?.email, {
    //   header: "아이디(이메일주소)",
    //   cell: (info) => {
    //     const val = info.getValue();

    //     const email =
    //       val?.length > 10 ? (
    //         <div>
    //           {val?.substring(0, 25)}
    //           <br />
    //           {val?.slice(25)}
    //         </div>
    //       ) : (
    //         val
    //       );
    //     return <div className="line-clamp-2">{val ? email : "-"}</div>;
    //   },
    // }),

    // columnHelper.accessor((row) => row?.hospitalMember?.name, {
    //   header: "병원명",
    //   cell: (info) => {
    //     const val = info.getValue();
    //     return <div>{val ? val : "-"}</div>;
    //   },
    // }),

    columnHelper.accessor((row) => row?.title, {
      header: "문의 제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return <div>{title ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.question, {
      header: "문의 내용",
      cell: (info) => {
        const val = info.getValue();
        const question = val?.length > 15 ? val?.substring(0, 15) + "..." : val;
        return <div>{question ? question : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "문의일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.answeredAt, {
      header: "답변 일시",
      cell: (info) => {
        const val = info.getValue();
        const date = convertDateToDateTime(val);
        return <div>{val ? date : "-"}</div>;
      },
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      확인
    </button>
  );
}

export function Hospital1on1Table(props) {
  const { filter, id } = props;
  const { isEmpty, getDataTableProps } = useHospital1on1List(filter, id);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center text-[14px]">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={false}
          hasPageSizeFilter={false}
          hasSort={false}
          columns={columns(currentPage, pageSize, totalData)}
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
